import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalendarCheck"><Path d="M8.5 2H7V4H3V21H12V19.5H4.5V10H19.5V13H21V4H17V2H15.5V4H8.5V2Z" fill="currentColor"/><Path d="M22.3014 15.625L21.1232 14.6967L16.8522 20.1176L14.7562 17.9894L13.6875 19.0419L16.9774 22.3824L22.3014 15.625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarCheck;
